import { useParams } from "react-router-dom";
import styled from "styled-components";

import { GoBackButton } from "../../../../components/GoBackButton";
import { theme } from "../../../../helpers/theme";
import PackageEditForm from "./package-edit-form";
import { useQuery } from "@tanstack/react-query";
import { getPackageById } from "../../../../services/packages/get-by-id";
import { useState } from "react";
import { GetPackagesByIdPayload } from "../../../../services/packages/get-by-id/types";
import { LoadingBackDrop } from "../../../../components/loader";

const StorageAreaPackageEdit = () => {
  const { id } = useParams();
  const [packageToEdit, setPackageToEdit] = useState<GetPackagesByIdPayload>();

  const GetPackagesById = useQuery(
    ["GetPackagesById"],
    () =>
      getPackageById({
        id_opakowanie: id,
      }),
    {
      refetchOnMount: true,
      refetchOnWindowFocus: false,

      onSuccess(data) {
        setPackageToEdit(data.data.payload);
      },
    }
  );
  if (
    GetPackagesById.isLoading ||
    GetPackagesById.isRefetching ||
    packageToEdit === undefined
  ) {
    return <LoadingBackDrop loading={true} />;
  }
  return (
    <>
      <ButtonWrapper>
        <GoBackButton description={"Powrót"} goToUrl={-1} />
      </ButtonWrapper>
      <StorageAreaPackageEditContainer>
        <PackageEditForm packageId={id} packageToEdit={packageToEdit} />
      </StorageAreaPackageEditContainer>
    </>
  );
};

export default StorageAreaPackageEdit;

const StorageAreaPackageEditContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin-left: 0;
  margin-top: 0px;
  padding-top: 20px;

  @media (${theme.device.laptop}) {
    margin-left: 320px;
    width: 70%;
    margin-top: -50px;
  }
`;
const ButtonWrapper = styled.div`
  width: 70%;
  margin-left: 30px;
  // display: flex;
  // justify-content: flex-start;

  @media (${theme.device.laptop}) {
    margin-left: 320px;
  }
`;
